<template>
  <div
    class="font-display min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
  >
    <div class="max-w-sm w-full">
      <LogoFull width="215px" />

      <h1 class="text-2xl text-gray-darkest font-bold mt-8">
        Create an account
      </h1>

      <p class="text-sm text-gray-darkest">
        Or already have an account?
        <a
          class="text-violet cursor-pointer"
          href="https://directory.partnerpage.io"
        >
          Log in
        </a>
      </p>

      <TextField
        label="Company name"
        name="companyName"
        elId="companyName"
        @input-change="({ value }) => (companyName = value)"
        :field-validator="validateCompanyName"
      />

      <TextField
        label="Website"
        type="url"
        name="companyWebsite"
        elId="companyWebsite"
        @input-change="({ value }) => (website = value)"
        :field-validator="validateWebsite"
        style="border: 0; background: transparent; padding-left: 0; padding-right: 0;"
      />

      <TextField
        label="Full name"
        name="fullName"
        elId="fullName"
        @input-change="({ value }) => (fullName = value)"
        :field-validator="validateFirstAndLastName"
      />

      <TextField
        label="Work email address"
        type="email"
        name="email"
        elId="email"
        @input-change="({ value }) => (email = value)"
        :field-validator="validateEmail"
        style="border: 0; background: transparent; padding-left: 0; padding-right: 0;"
      />

      <TextField
        label="Password"
        type="password"
        name="password"
        elId="password"
        @input-change="({ value }) => (password = value)"
        :field-validator="validatePassword"
        style="border: 0; background: transparent; padding-left: 0; padding-right: 0;"
      />

      <Button
        text="Sign up"
        type="submit"
        icon-placement="left"
        v-on:button-click="attemptSignUp"
        class="bg-violet group relative w-full flex justify-center py-2 px-4 mt-6 border border-transparent text-sm font-medium rounded-md text-white hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
      >
        Sign up
      </Button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { apiService } from '@/utils/api/index';
import { mapActions } from 'vuex';
import '@/scss/commons/_variables.scss'; // Importing this solely to use Open Sans for now
import LogoFull from '@/components/DesignSystem/LogoFull';
import TextField from '@/components/DesignSystem/Inputs/TextField';
import Button from '@/components/DesignSystem/Button';
import {
  validateFirstAndLastName,
  validateEmail,
  validatePassword,
  validateCompanyName,
  validateWebsite,
} from '@/components/DesignSystem/validators';

export default {
  components: {
    LogoFull,
    TextField,
    Button,
  },

  data() {
    return {
      fullName: '',
      email: '',
      password: '',
      website: '',
      companyName: '',
      alertShowing: true,
      working: false,
    };
  },

  mounted() {
    apiService.init(process.env.VUE_APP_ROOT_API);
  },

  methods: {
    ...mapActions(['showUserMessage']),
    handleInputChange(payload) {
      this[payload.key] = payload.value;
    },
    async attemptSignUp() {
      if (this.working) {
        return;
      }
      this.working = true;

      if (
        this.fullName &&
        this.email &&
        this.password &&
        this.companyName &&
        this.website
      ) {
        axios
          .post('/auth/sign_up/', {
            firstName: this.fullName.split(' ')[0],
            lastName: this.fullName.split(' ')[1],
            email: this.email,
            password: this.password,
          })
          .then(res => {
            if (res.status === 200) {
              this.createDirectories(res.data.userPk);
            } else {
              this.$store.dispatch('showUserMessage', {
                message:
                  'Oops! Something went wrong on our end. Error Code: 01',
                success: false,
                persist: true,
              });
              this.working = false;
            }
          })
          .catch(e => {
            if (e.response) {
              this.$store.dispatch('showUserMessage', {
                message:
                  e.response.data.message ||
                  'Oops! Something went wrong on our end. Error Code: 02',
                success: false,
                persist: true,
              });
            } else {
              this.$store.dispatch('showUserMessage', {
                message:
                  'Oops! Something went wrong on our end. Error Code: 03',
                success: false,
                persist: true,
              });
            }
            this.working = false;
          });
      } else {
        this.$store.dispatch('showUserMessage', {
          message: 'Oops, please fill out all fields!',
          success: false,
          persist: true,
        });
        this.working = false;
      }
    },
    createDirectories(userPk) {
      axios
        .post(`/users/vendor/onboarding/`, {
          userPk,
          companyName: this.companyName,
          website: this.website,
        })
        .then(res => {
          if (res.status === 200) {
            this.$store.dispatch('showUserMessage', {
              message: 'Success 🥳',
              success: true,
              persist: true,
            });
          } else {
            this.$store.dispatch('showUserMessage', {
              message:
                res.statusText ||
                'Oops! Something went wrong on our end. Error Code: 04',
              success: false,
              persist: true,
            });
          }
          this.working = false;
        })
        .catch(e => {
          if (e.response) {
            this.$store.dispatch('showUserMessage', {
              message:
                e.response.statusText ||
                'Oops! Something went wrong on our end. Error Code: 05',
              success: false,
              persist: true,
            });
          } else {
            this.$store.dispatch('showUserMessage', {
              message: 'Oops! Something went wrong on our end. Error Code: 06',
              success: false,
              persist: true,
            });
          }
          this.working = false;
        });
    },
    validateFirstAndLastName,
    validateEmail,
    validatePassword,
    validateCompanyName,
    validateWebsite,
  },
};
</script>
